const common = {
    login: 'Login',
    getStarted: 'Get Started',
    learnMore: 'Learn More',
    bookNow: 'Book Now',
    viewDetails: 'View Details',
    backToTop: 'Back to Top',
    home: 'Home',
    features: 'Features',
    yourSaaS: 'La Dolce Vita',
    day: 'Day',
    days: 'Days',
    night: 'Night',
    nights: 'Nights',
    startingFrom: 'Starting from',
    and: 'and',
    relatedTrips: 'Related Trips',
    relatedDestinations: 'Related Destinations',
    relatedActivities: 'Related Activities',
    includedInTrips: 'Included in Trips',
    availableAtDestinations: 'Available at Destinations',
    includesDestinations: 'Includes Destinations',
    includesActivities: 'Includes Activities',
    overview: 'Overview',
    details: 'Details',
    gallery: 'Gallery',
    related: 'Related',
    duration: 'Duration',
    difficulty: 'Difficulty',
    price: 'Price',
    items: 'items',

    locations: 'Locations',
    requirements: 'Requirements',
    included: 'Included',
    highlights: 'Highlights',
    activities: 'Activities',
    activityNotFound: 'Activity Not Found',
    activityNotFoundDescription: 'The activity you are looking for does not exist.',
    destinationNotFound: 'Destination Not Found',
    destinationNotFoundDescription: 'The destination you are looking for does not exist.',
    productNotFound: 'Product Not Found',
    productNotFoundDescription: 'The product you are looking for does not exist.',
    backToHome: 'Back to Home',
    loading: 'Loading...',
    retry: 'Retry',
    map: 'Map',
    region: 'Region',
    origin: 'Origin',
    volume: 'Volume',
    additionalDetails: 'Additional Details',
    altitude: 'Altitude',
    surface: 'Surface',
    population: 'Population',
    density: 'Density',
    length: 'Length',
    aboveSeaLevel: 'a.s.l.',
    updatedOn: 'updated on',
    between: 'between',
    andMeters: 'and',
    meters: 'meters'
};

export default common;
